import React, { useState, useEffect } from "react";

import { Button, Result, Spin, message } from "antd";

import { Http } from "../Http";
import queryString from "query-string";

import styles from "./Bridge.module.less";

function Bridge({ location, navigate }) {
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const goUrl = () => {
    navigate(`/welcome`);
  };

  const getBridge = async () => {
    let para = queryString.parse(location.search);
    let parsed = await Http.get(`bridge`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setAuth(true);
    }
  };

  const onLoading = async () => {
    setLoading(true);
    try {
      await getBridge();
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onLoading();
  }, []);

  useEffect(() => {
    if (auth === true && countdown > 0) {
      let handle = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => {
        clearInterval(handle);
      };
    }
    if (countdown === 0) {
      goUrl();
    }
  }, [auth, countdown]);

  const Wait = () =>
    auth ? (
      <Result
        status="success"
        title="登陆成功"
        subTitle={`您已成功登陆系统, 3秒之后立即跳转, 倒计时${countdown}秒`}
        extra={
          <Button type="primary" key="go" onClick={goUrl}>
            立即跳转
          </Button>
        }
      />
    ) : (
      <Result
        status="error"
        title="登陆失败"
        subTitle="请您返回中台再次尝试登陆, 如果还是登陆不上请联系客服"
      />
    );

  return (
    <div className={styles.Bridge}>
      {loading ? <Spin size="large" /> : <Wait />}
    </div>
  );
}

export default Bridge;
